import React, { createContext, useContext, useEffect } from 'react';
import { useChats } from '../hooks/useChats';
import { useAuth } from '../context/AuthContext';
import { useSocketContext } from './SocketContext';

const ChatsContext = createContext<ReturnType<typeof useChats> | null>(null);

export const ChatsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const chats = useChats();
  const { user, isAuthenticated } = useAuth();
  const socket = useSocketContext();

  useEffect(() => {
    if (isAuthenticated && user && socket?.getConnectionStatus()) {
      console.log('ChatsContext: Загрузка чатов при инициализации');
      chats.loadChats();
    }
  }, [isAuthenticated, user, socket, chats.loadChats]);

  useEffect(() => {
    console.log('ChatsContext: Количество чатов изменилось:', chats.chats.length);
  }, [chats.chats.length]);

  return <ChatsContext.Provider value={chats}>{children}</ChatsContext.Provider>;
};

export const useChatsContext = () => {
  const ctx = useContext(ChatsContext);
  if (!ctx) {
    throw new Error('useChatsContext must be used within ChatsProvider');
  }
  return ctx;
};
